import { getPickingDescription } from './getPickingDescription';
import { CountTextLines } from './types';

const NB_CHARS_PER_LINE = 40;

const createDomBasedCounter = (): CountTextLines => {
  if (typeof document === 'undefined') {
    return createEstimateCounter();
  }

  const div = document.createElement('div');

  return piece => {
    const html = getPickingDescription(piece);
    div.innerHTML = html;
    const text = div.textContent || (div as HTMLElement).innerText || '';

    return Math.max(1, Math.floor(text.length / NB_CHARS_PER_LINE) + 1);
  };
};

const createEstimateCounter = (): CountTextLines => {
  return piece => {
    const html = getPickingDescription(piece);
    const textLength = html.replace(/<[^>]+>/g, '').length;

    return Math.max(1, Math.ceil(textLength / NB_CHARS_PER_LINE));
  };
};

export const createTextLineCounter = (
  strategy: 'dom' | 'estimate',
): CountTextLines => {
  if (strategy === 'dom') {
    return createDomBasedCounter();
  }
  return createEstimateCounter();
};

export { NB_CHARS_PER_LINE };
